import { render, staticRenderFns } from "./search-bar-articles.vue?vue&type=template&id=415c7dcf"
import script from "./search-bar-articles.vue?vue&type=script&lang=js"
export * from "./search-bar-articles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports